<template>
    <span class="partner_experience" @click="onModalClick" @focusout="showPEModal = false" tabindex="0">
        <img src="@/assets/handshake_sm@2x.png" height="8px"/> Partner Experience 
        <div class="pemodal" v-if="showPEModal"><div class='arrow'></div>This experience is at one of our partner locations</div>
    </span>
</template>

<script>
export default {
  name: "PartnerExperienceTag",
    data() {
    return {
      showPEModal: false
    };
  },
  methods: {
    onModalClick(evnt) {
      evnt.stopPropagation()
      this.showPEModal = true
    },
  }
};
</script>

<style scoped>
.partner_experience{
    position: relative;
    display: inline-block;
    padding:2px 5px;
    color:Black;
    border-radius: 5px;
    border:1px solid black;
    font-size:8pt;
    font-family: inherit;
    cursor: pointer;
}
.partner_experience:focus{
    border-color: black;
    outline:none;
}
.pemodal {
    position:absolute;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    padding:10px 15px;
    top:-67px;
    left:-30px;
    z-index:1000;
    height:32px;
    width:150px;
    border: 1px solid rgba(0, 0, 0, 0.25);
}
.pemodal .arrow {
    /* Position at the top left corner */
    display: block;
    left: 74px;
    position: absolute;
    top: 52px;

    /* Border */
    background-color: #FFF;
    border-right: 1px solid rgba(0, 0, 0, 0.25);
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
    transform: translate(50%, -50%) rotate(45deg);

    /* Size */
    height: 16px;
    width: 16px;
}
.small {
    font-size: 6pt;
    padding:1px 3px;
    top:-1px;
}
.small img {
    position: relative;
    top:1px;
}

</style>
